import { gql } from '@apollo/client';

export const ACTIVITY = gql`
  query Activity($skip: Int, $take: Int) {
    activity(skip: $skip, take: $take) {
      dateTime
      payload {
        title
        value
      }
      type
      user {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

export const COLLECT_HISTORY = gql`
  query CollectHistory($collectOverviewId: ID!, $skip: Int, $take: Int) {
    collectHistory(collectOverviewId: $collectOverviewId, skip: $skip, take: $take) {
      dateTime
      payload {
        title
        value
      }
      type
      user {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

export const REPORT_INPUT_HISTORY = gql`
  query ReportInputHistory($reportId: ID!, $reportSectionId: ID) {
    reportInputHistory(reportId: $reportId, reportSectionId: $reportSectionId) {
      dateTime
      payload {
        title
        value
      }
      type
      user {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;
